import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { Actions, ofType } from '@ngrx/effects';
import { State } from '../../../../core/store';
import { Store } from '@ngrx/store';
import { SelectItem } from 'primeng/api';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { loadEmployeeUsers, loadViewableCampuses } from '../../../../core/store/employee/employee.action';
import { approveFormSubmission, approveFormSubmissionSuccess, getFormApprovalQueue, getUploadDocApprovalCount, loadFormApprovalFormList } from '../../../../core/store/queues/queues.action';
import { FormApprovalQueueModel } from '../../../../models/queueModels';
import { deepClone, downloadFile, getOptoLinkFromUrl } from '../../../../helpers/utils';
import { tap } from 'rxjs';
import { loadFormDoc, loadFormDocSuccess } from '../../../../core/store/form-builder/form-builder.actions';
import { UserAutoCompleteItem } from '../../../../models/utilModels';

@Component({
    selector: 'app-form-approval',
    templateUrl: './form-approval.component.html',
    styleUrls: ['./form-approval.component.scss'],
    standalone: false
})
export class FormApprovalComponent extends BaseComponent implements OnInit {

  list: PagingResultsModel<FormApprovalQueueModel>;
  filter: any;

  loadingDoc: boolean = false;
  loadingList: boolean = true;

  campusList: SelectItem[];
  campusId: number = 0;

  selectedUserEmployee: UserAutoCompleteItem;
  userEmployeeList: UserAutoCompleteItem[];
  userId: number = 0;  

  formList: SelectItem[];
  formId: number = 0;

  uploadDocApprovalCount: number = 0;

  canManage;
  
  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(
    private actions$: Actions,
    private store: Store<State>
  ) {
    super();
  }

  ngOnInit(): void {
    this.subs.push(
      this.store.select(s => s.queuesState.loadingFormApprovalQueue).subscribe(loading => {
        this.loadingList = loading;
      }),
      this.store.select(s => s.formBuilderState.loadingDoc).subscribe(loadingDoc => {
        this.loadingDoc = loadingDoc;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canManage = permissionIDs && !!permissionIDs.find(p => p === 6100); //Approve document upload //DO WE NEED A NEW PERMISSION
      }),
      this.store.select(s => s.employeeState.campuses).subscribe(campuses => {
        this.campusList = campuses && campuses.length > 0 ? campuses
          : [{ label: 'loading...', value: undefined }];
      }),
      this.store.select(s => s.queuesState.formApprovalFormList).subscribe(types => {
        if (types && types.length > 0) {
          this.formList = types.map(x => ({ label: x.label, value: x.value }));
          this.formList.unshift({ label: 'All', value: 0 });
        }
        else {
          this.formList = [{ label: 'loading...', value: undefined }]
        }
      }),
      this.store.select(s => s.queuesState.uploadDocApprovalCount).subscribe(count => {
        this.uploadDocApprovalCount = count;
      }),
      this.store.select(s => s.employeeState.employeeUsers).subscribe(users => {
        this.userEmployeeList = users.map(x => ({
          id: x.value,
          name: x.label
        }));
      }),      
      this.store.select(s => s.queuesState.formApprovalQueue).subscribe(report => {
        this.list = report;
        if(report != null)
     	  	  	  this.totalRecords.set(report.totalRecords);
      }),
      this.actions$.pipe(
        ofType(loadFormDocSuccess),
        tap(action => {
          downloadFile(action.doc, 'FormSubmission.pdf');
        })
      ).subscribe(),
      this.actions$.pipe(
        ofType(approveFormSubmissionSuccess),
        tap(action => {
          this.reloadList();
        })
      ).subscribe(),            
    );
   
    this.store.dispatch(loadViewableCampuses());
    this.store.dispatch(loadFormApprovalFormList());
    this.store.dispatch(getUploadDocApprovalCount());
  }

  reloadFilter(event) {
    this.filter = event;
    this.reloadList();
  }

  reloadList() {
    this.setFilter();

    this.store.dispatch(getFormApprovalQueue({
      filter: this.filter
    }));
  }

  getStaffList(event) {
    this.store.dispatch(loadEmployeeUsers({
      prefixText: event.query,
      programId: this.campusId,
      payrollClassificationId: null,
      showTerminated: false,
      showInactive: false
    }));
  }

  reloadListAfterStaffChange(selectedUser) {
    if (typeof selectedUser.value.id !== 'number') {
      return;
    }

    this.userId = selectedUser.value.id;
    this.reloadList();
  }

  reloadListAfterClear(event) {    

    this.userId = 0;
    this.reloadList();
  }

  setFilter() {
    this.filter = deepClone(this.filter);
    this.filter.filters.userId = { Name: 'userId', Value: { value: this.userId.toString() } };
    this.filter.filters.programId = { Name: 'programId', Value: { value: this.campusId.toString() } };
    this.filter.filters.formId = { Name: 'formId', Value: { value: this.formId } };
  }

  getTerminationString(list) {
    if (list.terminationDate != null) {
      return "(Separated)";
    }

    if (list.inactive) {
      return "(Inactive)"
    }

    return "";
  }

  seeFormResult(model: FormApprovalQueueModel) {
    window.open('/form-builder/form-submission/' + model.formId + '/' + model.formSubmissionId, "_blank");
  }

  downloadForm(model: FormApprovalQueueModel) {
    //this.loadingDocAssignmentId = formAssignment.id;
    this.store.dispatch(loadFormDoc({ formSubmissionID: model.formSubmissionId }));
  }

  approveForm(model: FormApprovalQueueModel) {
    this.store.dispatch(approveFormSubmission({ formSubmissionId: model.formSubmissionId }));
  }

  editUser(model: FormApprovalQueueModel) {
    window.open(getOptoLinkFromUrl() + "/Administration/ManageUsers/Edit/" + model.userId);
  }
}
